import PropTypes from 'prop-types';
import { useCallback } from 'react';

import { Stack, TextField, IconButton, InputAdornment, Tooltip } from '@mui/material';
import Iconify from '../../../components/iconify/index.js';
import { DatePicker } from '@mui/x-date-pickers';

export default function CompanyTableToolBar({
    filters,
    onFilters,
    subsOptions,
    onExportCSV,
    onFilterReset
}){
    // const popover = usePopover();
    
    const handleFilterName = useCallback((event) => {
        onFilters('name', event.target.value)
    }, [onFilters])

    const handleDateFrom = useCallback((event) =>{
        onFilters('dateFrom', event)
    },[onFilters])

    const handleDateTo = useCallback((event) =>{
        onFilters('dateTo', event)
    },[onFilters])

    return (
        <>
            <Stack
                spacing={2}
                alignItems={{xs: 'flex-end', md: 'center'}}
                direction={{
                    xs: 'column',
                    md: 'row'
                }}
                sx={{
                    p: 2.5,
                    pr: {xs: 2.5, md: 1}
                }}
            >


                <Stack direction="row" alignItems="center" spacing={2} flexGrow={1} sx={{ width: 1}} >
                    <TextField
                    fullWidth
                    value={filters?.name}
                    onChange={handleFilterName}
                    placeholder="Search..."
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Iconify icon="eva:search-fill" sx={{color: 'text.disabled'}} />
                            </InputAdornment>
                        )
                    }}
                    />

                <DatePicker
                  label="Start Date From"
                  format='dd/MM/yyyy'
                  onChange={handleDateFrom}
                  value={filters?.dateFrom}
                  slotProps={{
                    textField: {
                      fullWidth: true
                    },
                  }}
                  sx={{width: 410}}
                  renderInput={(params) => <TextField {...params} />}
                />

                    <DatePicker
                  label="Start Date To"
                  format='dd/MM/yyyy'
                  onChange={handleDateTo}
                  value={filters?.dateTo}
                  slotProps={{
                    textField: {
                      
                    }
                  }}
                  sx={{width: 410}}
                  renderInput={(params) => <TextField {...params} />}
                />
                 <Tooltip title="Reset Filter">
                     <IconButton color="error" onClick={onFilterReset} sx={{ width: 50, height: 50 }}>
                        <Iconify icon="bx:reset" />
                    </IconButton>
                 </Tooltip>

                <Tooltip title="Export CSV">
                    <IconButton color="secondary" onClick={onExportCSV} sx={{ width: 50, height: 50 }}>
                        <Iconify icon="hugeicons:csv-02" />
                    </IconButton>
                 </Tooltip>
            
                </Stack>


            </Stack>
        </>
    )
}

CompanyTableToolBar.propTypes = {
    filters: PropTypes.object,
    onFilters: PropTypes.func,
    onFilterReset: PropTypes.func,
    subsOptions: PropTypes.array,
    onExportCSV: PropTypes.func,
}